module.exports = __webpack_public_path__ + "38cbaef0644e64f6332b454c2c2b5ed2.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-3/bg.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-3/bg.jpg
// module chunks = 40